import { useParams } from 'react-router-dom';
import { useAddOnQuery } from '../hooks/useAddOnQuery';
import { useAddOnMutations } from '../hooks/useAddOnMutations';
import { AddOnForm } from '../components/AddOnForm';
import type { AddOnFormValues } from '../schemas/addon.schema';
import { Alert, TextLink } from '@/shared/components';

export function AddOnEdit() {
    const { id } = useParams<{ id: string }>();
    const query = useAddOnQuery(id);
    const { updateMutation } = useAddOnMutations();

    if (!id) return <p className="text-mp-error">Invalid optional extra ID.</p>;
    if (query.isLoading) return <p>Loading optional extra...</p>;
    if (query.isError || !query.data) {
        return <Alert variant="error"><span>Optional extra not found or failed to load.</span></Alert>;
    }

    const handleSubmit = (data: AddOnFormValues) => {
        updateMutation.mutate({ id, payload: data });
    };

    return (
        <section className="space-y-4">
            <div className="flex items-center gap-2">
                <TextLink to={`/smr-admin/addons/${id}`} color="secondary" className="text-sm">&larr; Back to Optional Extra</TextLink>
            </div>
            <h1 className="text-2xl font-semibold">Edit: {query.data.name}</h1>
            <AddOnForm
                initialValues={query.data}
                onSubmit={handleSubmit}
                isLoading={updateMutation.isPending}
                submitLabel="Save Changes"
            />
        </section>
    );
}
